/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';

import AddIcon from '@material-ui/icons/Add';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { Box, IconButton, Button } from '@material-ui/core';

const AddButton = ({ onExecute }) => {
  return (
    <Box m={1}>
      <Button
        color="primary"
        variant="contained"
        onClick={onExecute}
        title="Create new row"
        style={{ width: 40, borderRadius: 5 }}
      >
        <AddIcon style={{ fontSize: 26 }} />
      </Button>
    </Box>
  );
};

const EditButton = ({ onExecute }) => {
  return (
    <IconButton style={{ padding: 8 }} onClick={onExecute} title="Edit row">
      <EditOutlinedIcon style={{ fontSize: 22, color: '#729aaf' }} />
    </IconButton>
  );
};

const DeleteButton = ({ onExecute }) => {
  return (
    <IconButton
      onClick={() => {
        if (window.confirm('Are you sure you want to delete this row?')) {
          onExecute();
        }
      }}
      title="Delete row"
      style={{ padding: 8 }}
    >
      <DeleteOutlinedIcon style={{ fontSize: 22, color: '#a76f9a' }} />
    </IconButton>
  );
};

const CommitButton = ({ onExecute }) => {
  return (
    <IconButton style={{ padding: 8 }} onClick={onExecute} title="Save">
      <CheckIcon style={{ fontSize: 22, color: '#2e7d32' }} />
    </IconButton>
  );
};

const CancelButton = ({ onExecute }) => {
  return (
    <IconButton style={{ padding: 8 }} onClick={onExecute} title="Cancel">
      <CloseIcon style={{ fontSize: 22, color: '#9e9e9e' }} />
    </IconButton>
  );
};

const commandComponents = {
  add: AddButton,
  edit: EditButton,
  delete: DeleteButton,
  commit: CommitButton,
  cancel: CancelButton,
};

export const Command = ({ id, onExecute }) => {
  const CommandButton = commandComponents[id];
  if (!CommandButton) {
    return null;
  }
  return <CommandButton onExecute={onExecute} />;
};
